import { CaretDownOutlined } from '@ant-design/icons';
import { diffDates, formatDate } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { translateHour, translateMinute } from 'util/translation/wordForm';
import { MEASUREMENT_FORMAT } from 'state/global/profile/util/constant';
import { CleanedSquareValue } from 'components/UI/CleanedSquareValue';

const onClickMachineAlias = ({ history, machine }) => {
  history.push(`/my-machines/${machine.id}`);
};

export const roundBy5 = (value) => {
  if (value < 1) {
    value *= 100;
  }
  return Math.ceil(Math.round(value) / 5) * 5;
};

export const renderColumns = ({ history, t, measurementFormat }) => [
  {
    title: t('cleaningReportTable.columns.machine'),
    dataIndex: 'machineAlias',
    render: (machineAlias, { machine }) => {
      const { materialNumber } = machine;

      return (
        <div
          onClick={() => onClickMachineAlias({ history, machine })}
          aria-hidden="true">
          {getMachineType(materialNumber)} / {machineAlias}
        </div>
      );
    }
  },
  {
    title: t('cleaningReportTable.columns.routeName'),
    dataIndex: 'routeName'
  },
  {
    title: t('cleaningReportTable.columns.taskCompletion'),
    dataIndex: 'taskCompletion',
    render: (taskCompletion) => {
      return t(`taskCompletionMapping.${taskCompletion}`);
    }
  },
  {
    title: t('cleaningReportTable.columns.coverage'),
    dataIndex: 'pathCoverage',
    render: (pathCoverage) => {
      return <span>{roundBy5(pathCoverage)} %</span>;
    }
  },
  {
    title: t('cleaningReportTable.columns.object'),
    dataIndex: 'machineObject'
  },
  {
    title: () => {
      return (
        <div className="display-flex items-center justify-between">
          {t('cleaningReportTable.columns.date')}
          <CaretDownOutlined />
        </div>
      );
    },
    dataIndex: 'endDate',
    render: (endDate) => {
      return formatDate(endDate, { shortFormat: true });
    }
  },
  {
    title:
      measurementFormat === MEASUREMENT_FORMAT.METRIC
        ? t('cleaningReportTable.columns.cleanedMeterSquare')
        : t('cleaningReportTable.columns.cleanedFeetSquare'),
    dataIndex: 'cleanedSquareMeter',
    render: (cleanedSquareMeter) => {
      return <CleanedSquareValue cleanedSquareMeter={cleanedSquareMeter} />;
    }
  },
  {
    title: t('cleaningReportTable.columns.duration'),
    // eslint-disable-next-line react/prop-types
    render: ({ startDate, endDate }) => {
      const { hours, minutes } = diffDates(startDate, endDate);
      const time = [];
      if (hours) time.push(translateHour(t, hours));
      if (minutes) time.push(translateMinute(t, minutes));
      return time.join(' ');
    }
  }
];
